import { useMutation } from "@tanstack/react-query";
import { communicationServices } from "./communication.services";

export const useCreateCommunication = () => {
  return useMutation({
    mutationFn: communicationServices.createCommunication,
  });
};
